<div id="map"></div>
<app-event-table></app-event-table>
<app-form></app-form>